<template>
    <div>

        <div class="product-qty first" v-if="product">
            <div :class="['pricebox', {'stock-avaiability-error': product.max_qty != null && product.qty > product.max_qty}]">
                <!-- {{ product }}<br>
                        t={{ product.inventory_tracking }} | q={{ product.inventory_quantity }} -->
                <div class="icon-error" v-if="product.max_qty != null && product.qty > product.max_qty"><i class="fa-solid fa-triangle-exclamation"></i></div>
                <div :class="['icon-cart-del' ]" @click="del" v-on:dblclick="" v-if="!mchange"> - </div>
                <div class="product-qty">
                    {{ product.qty }} {{ __('__JSON__.db') }}
                </div>
                <div class="icon-cart-add" @click="add" v-on:dblclick="" v-if="!mchange"> + </div>

            </div>
        </div>
        <!-- <cart-del :product="product"></cart-del> -->
        <!-- <div class="product-image"  :style="{ 'background-image':  `url(${product.photo})`} "  @click="link"></div> -->
        <!-- <div class="product-image"  :product="product"> -->
        <!-- <div class="product-name">{{ product.product_name }}</div>
                <div class="product-price">{{ product.price_plus_vat }} {{ product.currency }} </div> -->
        <br />
        <!-- </div> -->
        <!-- <product-qty :product="product" ></product-qty> -->
    </div>
</template>

<script>
import Vue from 'vue';

import mixin from '../../mixin.js'
export default {

    props: ['cart', 'product'],
    mixins: [mixin],
    data: function() {
        return {
            timer: 0,

            delayed_qty: 0,
            delayed_ajax: false,

            mchange: false, // jelenleg nem hasznalt
            cart_index: -1,
            qty_data: {
                0: {
                    "product_id": this.product.product_id,
                    "qty": this.product.qty
                }
            }
        }
    },
    mounted: function() {
        console.log('roastopus-cart-element-small.vue mounted...');
        console.log('this.product', this.product);
        this.in_cart;
    },
    computed: {
        in_cart: function() {
            console.log('computed: in_cart()');
            var ret;

            if (this.$root.cart.cart.data !== 'undefined') {

                ret = this.$root.cart.cart.data.findIndex((k) => k.product_id == this.product.product_id) > -1 ? 1 : 0;
                this.cart_index = this.$root.cart.cart.data.findIndex((k) => k.product_id == this.product.product_id);

            } else {

                this.cart_index = -1;
                // console.warn('incart UNDEFINED!');
            }
            console.info('this.cikkszam=' + this.product.product_id + ' | computed: this.cart_index  = ' + this.cart_index);
            this.$forceUpdate();
            return ret;

        },
        in_stock: function() {
            //console.log(this.keszletinfo);
            // return this.keszletinfo != 'nincs' ? 1 : 0;
            return 1;
        },
        // vprice_pv: function() { //bruttora
        //     // console.warn('------------vbruttoar|'+this.termek.v_bruttoar);
        //     return parseInt(this.product.price_plus_vat).formatMoney(0,  ' ', ' ');
        // },
        // total_price: {
        //     get: function(){
        //         return parseInt(this.product.price_plus_vat * this.product.qty)
        //     },
        //     set: function(){
        //     }
        // }
    },
    methods: {
        // runfirst: function() {
        //     this.in_cart;
        // },
        add: function() {
            console.log('roastopus-cart-element-small add(): ' + this.product.product_id + '|' + this.product.product_name);
            // if (!this.mchange) {
            // if (this.qty_data[0]['qty'] < 98) {
            if ((!this.product.inventory_tracking && this.qty_data[0]['qty'] < 98) || (this.product.inventory_tracking && this.product.max_qty > 0 && (this.qty_data[0]['qty'] < this.product.max_qty))) {
                console.log('plus plus');
                this.delayed_qty++;
                this.qty_data[0]['qty']++;

                // console.log(this.qty_data[0]['qty']);

                if (this.in_cart) {
                    // a rendes vue kosarbol veszi a darabszamot, ez a biztos
                    // console.log(this.$root.cart.cart.data[0].qty);
                    this.cart_index = this.$root.cart.cart.data.findIndex((k) => k.product_id == this.product.product_id);
                    console.log('van a kosarban, ezert++|' + this.cartindex);
                    this.$root.cart.cart.data[this.cart_index].qty = this.qty_data[0]['qty'];
                    // console.info(this.$root.kosar);
                } else {
                    console.log('nincs a kosarban, beteszem->');
                    var newproduct = {
                        price: this.product.price,
                        price_plus_vat: this.product.price_plus_vat,
                        product_id: this.product.product_id,
                        product_name: this.product.product_name,
                        currency: this.product.currency,
                        packaging_qty: this.product.packaging_qty,
                        packaging_qty_unit: this.product.packaging_qty_unit,
                        vat: this.product.vat,
                        qty: 1

                    };
                    this.$root.cart.cart.data.unshift(newproduct);
                    this.cart_index = this.$root.cart.cart.data.findIndex((k) => k.product_id == this.product.product_id);
                    this.qty_data[0]['qty'] = 1;
                    this.qty_data[0]['product_id'] = this.product.product_id;
                }
                if (this.delayed_ajax) {
                    clearTimeout(this.timer);
                }
                this.addTimeoutToCart();
            }
            // }
            // }
            this.$forceUpdate();
        },
        addTimeoutToCart: function() {
            this.delayed_ajax = true;
            var self = this;
            this.timer = setTimeout(function() {
                self.delayed = false;
                self.cartAdd();
                self.delayed_ajax = false;
            }, 1000);

        },



        del: function() {
            console.log('del:' + this.product.product_id + '|' + this.product.product_name);

            if (this.qty_data[0]['qty'] > 0) {
                this.qty_data[0]['qty']--;
                if (this.in_cart) {
                    this.cart_index = this.$root.cart.cart.data.findIndex((k) => k.product_id == this.product.product_id);
                    this.$root.cart.cart.data[this.cart_index].qty = this.qty_data[0]['qty'];
                }
                this.delayed_qty--;
                if (this.delayed_ajax) {
                    clearTimeout(this.timer);
                }
                if (this.qty_data[0]['qty'] < 1) {
                    self = this;
                    Vue.nextTick(function() {

                        // self.$root.cart.cart.data.splice(self.$root.cart.cart.data.findIndex((k) => k.product_id == self.product.product_id), 1);
                    });

                }
                this.delTimeoutToCart();
                this.$forceUpdate();
            } else {
                console.log('NULLANAL KISEBB');
                console.warn(this.qty_data[0]);
                console.log('delend:' + this.product.product_id + '|' + this.product.product_name);

            }
        },

        delTimeoutToCart: function() {
            this.delayed_ajax = true;
            var self = this;
            this.timer = setTimeout(function() {
                self.delayed = false;
                self.cartDel();
                self.delayed_ajax = false;
            }, 1000);

        },
        cartAdd: function() {
            this.$root.cartmenu_loading = true;
            axios
                .post('/api/v1/cart', { data: { 0: { product_id: this.product.product_id, qty: this.delayed_qty } } })
                .then(response => {
                    this.$root.cartmenu_loading = false;
                    var self = this;
                    console.log(self.$root.cart);
                    console.warn(response.data);
                    self.$root.cart = response.data;
                    self.mchange = false;
                    console.log('ajax response: OK');
                    // console.log(self.$root.cart);
                    if (response.data) {
                        self.delayed_qty = 0;

                        self.$forceUpdate();
                        this.$notify({
                            type: "success",
                            title: this.__("__JSON__.Kosár"),
                            text: this.__("__JSON__.A terméke(ke)t a kosárba tettem!"),
                            position: "left",
                            group: 'appnotif',

                            autohide: false,
                            timeout: 5000,
                        });
                        // console.log
                        //
                        //         // if (google_datalayer_cart) {
                        //         //     ga('send', 'event', {
                        //         //         eventCategory: 'addToCart',
                        //         //         eventAction: 'click',
                        //         //         eventLabel: self.termeknev,
                        //         //         eventValue: 1
                        //         //     });
                        //         // }
                        //         // if (fbq_datalayer_cart) {
                        //         //     fbq('track', 'AddToCart', {
                        //         //         content_ids: [self.cikkszam],
                        //         //         content_type: 'product',
                        //         //         value: self.v_bruttoar,
                        //         //         currency: 'HUF'
                        //         //     });
                        //         // }
                        //     //});
                    }
                })

                .catch(error => {});

        },
        cartDel: function() {
            this.$root.cartmenu_loading = true;
            axios
                .post('/api/v1/cart', { data: { 0: { product_id: this.product.product_id, qty: this.delayed_qty } } })
                .then(response => {
                    if (response.data) {
                        this.$root.cartmenu_loading = false;
                        var self = this;
                        console.log(self.$root.cart);
                        self.$root.cart = response.data;
                        // self.$root.cart.cart.data = {};
                        self.$forceUpdate();



                        self.mchange = false;
                        console.log('ajax response: OK');
                        console.log(this.$root.cartmenu_loading);

                        // console.warn(response.data);
                        // console.log(self.$root.cart);
                        // if (this.in_cart) {
                        self.$forceUpdate();
                        self.$root.$refs.cartbox.$forceUpdate();
                        self.$root.$forceUpdate();
                        this.$root.cartmenu_loading = false;
                        this.cart_index = this.$root.cart.cart.data.findIndex((k) => k.product_id == this.product.product_id);
                        // this.$root.cart.cart.data[this.cart_index].qty = this.qty_data[0]['qty'];
                        // } else {
                        console.warn('??cart_index = ' + this.cart_index);
                        //     this.cart_index = -1;
                        //     this.qty_data[0]['qty'] = 0;
                        // }

                        self.delayed_qty = 0;
                        this.$notify({
                            type: "success",
                            title: this.__("__JSON__.Kosár"),
                            text: this.__("__JSON__.A terméke(ke)t a kosárból kivettem!"),
                            position: "left",
                            group: 'appnotif',

                            autohide: false,
                            timeout: 5000,
                        });
                        // console.log
                        //
                        //         // if (google_datalayer_cart) {
                        //         //     ga('send', 'event', {
                        //         //         eventCategory: 'addToCart',
                        //         //         eventAction: 'click',
                        //         //         eventLabel: self.termeknev,
                        //         //         eventValue: 1
                        //         //     });
                        //         // }
                        //         // if (fbq_datalayer_cart) {
                        //         //     fbq('track', 'AddToCart', {
                        //         //         content_ids: [self.cikkszam],
                        //         //         content_type: 'product',
                        //         //         value: self.v_bruttoar,
                        //         //         currency: 'HUF'
                        //         //     });
                        //         // }
                        //     //});
                    }
                })

                .catch(error => {});

        }
    }

}
</script>
